module.exports = __webpack_public_path__ + "static/media/23.2b763e96.png";